import React from 'react'
import { Link } from 'react-router-dom'
import { routeService } from '../services/route.service'
import { OPEN_COOKIE_SETTINGS_EVENT } from './CookieConsentBanner'

interface AppFooterProps {
    readonly companyName: string,
    readonly year: number
}
export function AppFooter({ companyName, year }: AppFooterProps) {
    function openCookieSettings() {
        window.dispatchEvent(new Event(OPEN_COOKIE_SETTINGS_EVENT));
    }

    return (
        <footer className="flex flex-col md:flex-row items-center justify-between gap-3 p-4 w-full border-t bg-gray-900 dark:bg-gray-600">
            <aside className="items-center grid gap-2 grid-flow-col text-gray-400">
                <p>Copyright ©{companyName} {year} - All rights reserved</p>
            </aside>
            <nav className="flex items-center gap-6 text-sm text-gray-300">
                <Link to={routeService.PRIVACY_POLICY} className="hover:text-white underline">
                    Privacy Policy
                </Link>
                <button
                    type="button"
                    onClick={openCookieSettings}
                    className="hover:text-white underline"
                >
                    Cookie settings
                </button>
            </nav>
        </footer>
    )
}


